import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from './PeopleCard.module.css';
import { usePeopleCard } from './usePeopleCard';
import { Icon } from '../../../../../components/newUI/Icon/Icon';
import { Roles } from '../../../../AddProject/types/types';

interface PeopleCardProps {
    classes?: string;
    employerId: number;
    onDelete?: () => void;
    type?: string;
}

export const PeopleCard = ({ classes, employerId, type = '' }: PeopleCardProps) => {
    const { t } = useTranslation();
    const { onDeleteEmployer, projectUser, managers } = usePeopleCard(employerId);
    return (
        <div className={classNames(cls.PeopleCard, [classes])}>
            {type && type === Roles.MANAGER ? (
                Object.values(managers.entities).length > 1 && (
                    <UiButton
                        className={cls.DeleteCard}
                        onClick={onDeleteEmployer}
                        variant="icon"
                        startIcon={<Icon iconName="deleteCard" />}
                    />
                )
            ) : (
                <UiButton
                    className={cls.DeleteCard}
                    onClick={onDeleteEmployer}
                    variant="icon"
                    startIcon={<Icon iconName="deleteCard" />}
                />
            )}
            <div className={cls.Content}>
                <div className={cls.PeopleAvatar}>
                    {projectUser.avatar ? (
                        <img
                            src={projectUser.avatar}
                            alt={t('ProjectTeam.ProjectTeamInvite.PeopleCard.return.img.alt')}
                        />
                    ) : (
                        <Icon iconName="profileBigSize" />
                    )}
                </div>
                <div className={cls.PeopleInfo}>
                    <span className={cls.PeopleName}>{projectUser.name}</span>
                    <span className={cls.PeopleEmail}>{projectUser.email}</span>
                </div>
            </div>
        </div>
    );
};
